// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2pDqy","header":"PatientQuestionnaire_header__2urvs","info":"PatientQuestionnaire_info__1clYL"};